import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useModal } from 'shared/lib/hooks/useModal';

import { MiddleManModal } from './MiddleManModal';

export const HelpWithOrderButton = () => {
    const { t } = useTranslation();
    const { isModalOpen, openModal, closeModal } = useModal();

    return (
        <>
            <Button
                style={{ minWidth: '140px' }}
                variant="outlined"
                onClick={openModal}
                data-testid="btn-help-with-order"
            >
                {t('Help with order')}
            </Button>
            <MiddleManModal open={isModalOpen} onClose={closeModal} />
        </>
    );
};
